import { UserPermission } from '@/modules/permission/enum';
export const learningOutcomesRoutes = [
    {
        path: '',
        name: 'LearningOutcomes',
        exact: true,
        component: () => import('../views/LearningOutcomeList.vue'),
        meta: {
            breadcrumb: [{ label: 'All Learning Outcomes' }],
            permissions: [UserPermission.READ_LEARNING_OUTCOME],
        },
    },
];
